import { render, staticRenderFns } from "./DetalheCampanhaEmail.vue?vue&type=template&id=626291ea&scoped=true"
import script from "./DetalheCampanhaEmail.vue?vue&type=script&lang=js"
export * from "./DetalheCampanhaEmail.vue?vue&type=script&lang=js"
import style0 from "./DetalheCampanhaEmail.vue?vue&type=style&index=0&id=626291ea&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626291ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('626291ea')) {
      api.createRecord('626291ea', component.options)
    } else {
      api.reload('626291ea', component.options)
    }
    module.hot.accept("./DetalheCampanhaEmail.vue?vue&type=template&id=626291ea&scoped=true", function () {
      api.rerender('626291ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DetalheCampanhaEmail.vue"
export default component.exports